"use client";
import React, { useMemo, useState } from "react";
import { FmCheckbox, FmDrawer } from "@/ui-component";
import { IProps } from ".";
import { useRateContext } from "@/src/provider";
import stl from "./productPackageItem.module.scss";
import { useTranslation } from "@/src/i18n/client";

interface IPackageDetailClientProps extends IProps {}
const PackageDetailClient: React.FC<
    React.PropsWithChildren<IPackageDetailClientProps>
> = (props) => {
    const { t } = useTranslation("productDetail");
    const [getPrice] = useRateContext((state) => [state.getPrice]);
    const { data } = props;
    const { packageSpecialityList = [] } = data;
    const [isShowPackageDetail, setIsShowPackageDetail] = useState(false);
    const toggerModal = () => {
        setIsShowPackageDetail((prev) => !prev);
    };

    const packageDetailsView = () => {
        toggerModal();
    };

    const checkedItems = useMemo(() => {
        return packageSpecialityList
            .filter((item) => !!item?.transName)
            .map((item) => {
                return {
                    label: item.transName,
                    value: item.transName,
                    formControlLabelClassName: stl["label-item"],
                    disabled: true,
                };
            });
    }, [packageSpecialityList]);
    return (
        <>
            <div onClick={packageDetailsView}>{props.children}</div>
            {/* 套餐详情 */}
            <FmDrawer
                closeablePosition="right"
                closeable
                open={isShowPackageDetail}
                onClose={toggerModal}
                headerChildren={data.displayName}
                childrenClassName={stl["dialog-content"]}
                anchor="bottom"
            >
                <div className={stl["package-detail-modal"]}>
                    <div className={stl["text"]}>{data.descriptions}</div>
                    <FmCheckbox
                        dataSource={checkedItems}
                        values={packageSpecialityList
                            .filter((item) => !!item?.transName)
                            .map((item) => item.transName)}
                    />

                    {data.virtualCostPrice && (
                        <>
                            {data.virtualCostPrice - data.price > 0 && (
                                <p
                                    className={stl["price-text"]}
                                    dangerouslySetInnerHTML={{
                                        __html: `${t(
                                            "productDetail:PackageInfo.Save",
                                        )} ${getPrice(
                                            `${
                                                data.virtualCostPrice -
                                                data.price
                                            }`,
                                        )} ${t(
                                            "productDetail:PackageInfo.ComparedWithCustomization",
                                        )}`,
                                    }}
                                />
                            )}
                        </>
                    )}
                </div>
            </FmDrawer>
        </>
    );
};

export default PackageDetailClient;
